<p-card>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
      <div class="flex align-items-right" style="margin-left: auto;margin-right: 0;">
        <p-button (click)="show('Add State','')" styleClass="customAdd p-button-sm p-button-raised mr-1"
          icon="fa fa-plus p-button-icon ng-star-inserted" pTooltip="Add State" tooltipPosition="left"></p-button> 
      </div>
    </div>
  </div>

  <div class="mr-0 tablehiegt">
    <p-table #dt [value]="statelistarray" [customSort]="customsort" (sortFunction)="customSort($event)"
      [columns]="_selectedColumns" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}" sortField="username" columnResizeMode="expand" [customSort]="customsort"
      (sortFunction)="customSort($event)" [resizableColumns]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
      paginatorLocale="fa-IR" [paginator]="statelistarray.length > 0" [sortOrder]="1" responsiveLayout="scroll"
      (onPage)="handlePageChange($event)" sortField="statename">

      <!-- Search Input Section -->
      <ng-template pTemplate="caption">
        <div>
          <div class="grid table-header">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class="p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                  (input)="dt.filterGlobal($any($event.target).value, 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in State"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
            <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="exceDownloadModel()">
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Table Header -->
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">
              {{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter *ngIf="col.field !== 'activeflag'" type="text" [field]="col.field"
                display="menu"></p-columnFilter>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
                <i class="fa fa-edit" (click)="show('Modify State', data)"></i>
              </span>
            </div>
          </td>

          <!-- Data Columns -->
          <ng-container *ngFor="let col of _selectedColumns">
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class" tooltipPosition="left">
              <span *ngIf="col.field !== 'activeflag'" pTooltip="{{ data[col.field] }}">
                {{ data[col.field] }}
              </span>
              <span *ngIf="col.field === 'activeflag'">
                <i *ngIf="data[col.field] === 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field] !== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td> -->
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field !== 'activeflag'" pTooltip=" {{data[col.field]}}"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
              <span *ngIf="col.field === 'activeflag'">
                <i *ngIf="data[col.field] === 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field] !== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- No Data Found Message -->
  <div class="card" style="margin-top: -4px;" *ngIf="statelistarray.length == 0">
    <p-card>
      <p style="text-align: center;">Data not found...</p>
    </p-card>
  </div>
</p-card>